import { PrivateService } from "../auth/PrivateService";
import { BaseUriHolder } from "../utils/BaseUriHolder";

export class CompanyFollowerService {
    constructor() {
        this.baseUriHolder = new BaseUriHolder();
        this.privateService = new PrivateService();
    }

    saveFollowing(companyId) {
        let obj = {
            companyId : companyId
        }
        let uri = this.baseUriHolder.getJobSeeker() + '/company/follow';
        return this.privateService.postFetch(uri, obj);
    }

}